import { useState } from "react";
import { useNavigate } from "react-router-dom";
import facewash from "../images/facewash.jpg";
import shampoo from "../images/shampoo.jpg";
import cream from "../images/cream.jpg";
import aloegel from "../images/aloegel.jpg";
import acnecream from "../images/acnecream.jpg";

function ProductCard({ product, addToCart }) {
  const [isHovered, setIsHovered] = useState(false);
  const navigate = useNavigate();

  const imageMap = {
    "facewash.jpg": facewash,
    "shampoo.jpg": shampoo,
    "cream.jpg": cream,
    "aloegel.jpg": aloegel,
    "acnecream.jpg": acnecream,
  };

  const productImage =
    product.image && product.image.startsWith("http")
      ? product.image
      : imageMap[product.image];

  return (
    <div
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={() => navigate(`/product/${product.id}`)}
      style={{
        backgroundColor: "white",
        border: "1px solid #e5e7eb",
        borderRadius: "16px",
        padding: "18px",
        boxShadow: isHovered
          ? "0 10px 24px rgba(0,0,0,0.12)"
          : "0 4px 14px rgba(0,0,0,0.06)",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        minHeight: "460px",
        transform: isHovered ? "translateY(-6px)" : "translateY(0)",
        transition: "all 0.25s ease",
        cursor: "pointer",
      }}
    >
      <div
        style={{
          width: "100%",
          height: "200px",
          background: "#f3f4f6",
          borderRadius: "12px",
          marginBottom: "16px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
        }}
      >
        {productImage ? (
          <img
            src={productImage}
            alt={product.name}
            style={{
              maxWidth: "100%",
              maxHeight: "100%",
              objectFit: "contain",
              display: "block",
              transform: isHovered ? "scale(1.05)" : "scale(1)",
              transition: "transform 0.25s ease",
            }}
          />
        ) : (
          <span style={{ color: "#9ca3af", fontSize: "14px" }}>
            No Image
          </span>
        )}
      </div>

      <div style={{ textAlign: "center" }}>
        <p
          style={{
            margin: "0 0 8px 0",
            fontSize: "13px",
            fontWeight: "bold",
            color: "#16a34a",
          }}
        >
          {product.category}
        </p>

        <h3
          style={{
            margin: "0 0 10px 0",
            color: "#222",
            fontSize: "22px",
          }}
        >
          {product.name}
        </h3>

        <p
          style={{
            margin: "0 0 12px 0",
            color: "#666",
            fontSize: "14px",
            lineHeight: "1.5",
          }}
        >
          {product.description}
        </p>

        <p
          style={{
            fontWeight: "bold",
            fontSize: "18px",
            margin: "0 0 16px 0",
            color: "#111",
          }}
        >
          ₹{product.price}
        </p>
      </div>

      <button
        onClick={(e) => {
          e.stopPropagation();
          addToCart(product);
        }}
        style={{
          background: isHovered
            ? "linear-gradient(135deg, #16a34a, #15803d)"
            : "linear-gradient(135deg, #22c55e, #16a34a)",
          border: "none",
          padding: "12px 18px",
          color: "white",
          borderRadius: "8px",
          cursor: "pointer",
          fontWeight: "bold",
          fontSize: "14px",
          width: "100%",
          transition: "all 0.25s ease",
        }}
      >
        Add to Cart
      </button>
    </div>
  );
}

export default ProductCard;